import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Recording icon. Exported from Figma (Bombiix 2026). */
const RecordingIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <defs>
      <clipPath id="recording-icon-clip">
        <rect width="16" height="16" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
    <g clipPath="url(#recording-icon-clip)">
      <g>
        <path
          d="M17.3337 9.99935C17.3337 14.0494 14.0504 17.3327 10.0003 17.3327C5.95024 17.3327 2.66699 14.0494 2.66699 9.99935C2.66699 5.94926 5.95024 2.66602 10.0003 2.66602C14.0504 2.66602 17.3337 5.94926 17.3337 9.99935Z"
          stroke="currentColor"
        />
        <path
          d="M13.3337 9.99935C13.3337 11.8403 11.8413 13.3327 10.0003 13.3327C8.15938 13.3327 6.66699 11.8403 6.66699 9.99935C6.66699 8.1584 8.15938 6.66602 10.0003 6.66602C11.8413 6.66602 13.3337 8.1584 13.3337 9.99935Z"
          stroke="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default RecordingIcon;
